/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFolderFavorite = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="m13.42 12.612 2.58.557-1.953 1.87.411 2.961L12 16.69 9.542 18l.411-2.96L8 13.168l2.58-.557L12 10z" />
        <path d="M12.616 6h9.382v16h-20V2h8.618zM3.998 20h16V8H11.38l-2-4H3.998z" />
      </g>
    </g>
  </Icon>
);
export { SvgFolderFavorite as FolderFavorite };
